<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAssign()">Assign</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onUnassign()">Unassign</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete</button>
		<button [disabled]="IsLoading() == true" class="btn btn-success" style="margin-left: 5px" (click)="onExport()">Export</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onImport()">Import</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstLocker"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedLockers"
		dataKey="LockerID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--LockerNum-->
				<th>
					<p-columnFilter type="text" field="LockerNum" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Comment-->
				<th>
					<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AssignedComments-->
				<th>
					<p-columnFilter type="text" field="AssignedComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AssignedToDesc-->
				<th>
					<p-columnFilter type="text" field="AssignedToDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AssignedDT-->
				<th>
					<!-- <p-columnFilter type="text" field="AssignedDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--AssignableDesc-->
				<th>
					<p-columnFilter field="AssignableDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAssignableDesc
								[ngModel]="value"
								[options]="lstAssignableDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="LockerNum">Locker<p-sortIcon field="LockerNum"></p-sortIcon></th>
				<th pSortableColumn="Comment">Locker Comments<p-sortIcon field="Comment"></p-sortIcon></th>
				<th pSortableColumn="AssignedComments">Assigned Comments (Student's Combination)<p-sortIcon field="AssignedComments"></p-sortIcon></th>
				<th pSortableColumn="AssignedToDesc">Assigned To<p-sortIcon field="AssignedToDesc"></p-sortIcon></th>
				<th pSortableColumn="AssignedDT">Assigned Date<p-sortIcon field="AssignedDT"></p-sortIcon></th>
				<th pSortableColumn="AssignableDesc">Assignable<p-sortIcon field="AssignableDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Locker>
			<tr [pSelectableRow]="Locker" (dblclick)="onRowDblClick(Locker)">
				<td>
					<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Locker" [value]="Locker"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Locker[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Locker.Assignable == true ? 'Black' : 'Red'">
					{{ Locker["AssignableDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
